<template>
  <div id="app">
    <head-com-box v-if="$route.name !== 'login'">
      <router-view :key="key + $route.name" />
    </head-com-box>
    <router-view v-else />
  </div>
</template>

<script>
import headComBox from '@/components/headerComBox';
import {
  apiCollection,
  apiResource,
  apiFormSubmit,
  apiDelete,
  apiPut,
  apiCollectionbill,
  apiResourcebill
} from './api/index';
export default {
  name: 'App',
  components: {
    headComBox
  },
  computed: {
    key() {
      return this.$route.name !== undefined
        ? this.$route.name + new Date()
        : this.$route + new Date();
    }
  },
  created() {
    const loginToken = localStorage.getItem('x-token');
    const arr = [
      apiCollection,
      apiResource,
      apiFormSubmit,
      apiCollectionbill,
      apiResourcebill,
      apiDelete,
      apiPut
    ];
    if (loginToken) {
      arr.forEach(item => {
        item.defaults.headers['x-token'] = loginToken;
      });
    }
  }
};
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #333333;
}
body {
  margin: 0;
}
</style>



// WEBPACK FOOTER //
// src/App.vue